import BorderColorIcon from '@mui/icons-material/BorderColor';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import React, { useEffect, useState } from 'react';
import { Accordion, Col, Row, Stack } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { GenerateOrder } from '../../../../context/OrderContext';
import { useEditSelectedOrderDetailsMutation, useLazyGetAllActiveOpenOrdersQuery } from '../../../../features/Dispatch/DispatchSlice';
import { useGetOrderNotificationQuery, useLazyGetVehicleByIdQuery } from '../../../../features/order/orderSlice';
import { consignorNameSchema, createSchema, customerSchema, dimWgtSchema, dropOffCitySchema, dropoffClosingTimeSchema, dropoffCountrySchema, dropoffOpeningTimeSchema, dropoffPhoneNumberSchema, dropoffPostalCodeSchema, dropoffProvinceSchema, dropoffStreetNameSchema, dropoffStreetNumberSchema, dropoffUnitSchema, ftSchema, pcsSchema, pickupCitySchema, pickupCountrySchema, pickupPhoneNumberSchema, pickupPostalCodeSchema, pickupProvinceSchema, pickupStreetNameSchema, pickupStreetNumberSchema, pickupUnitSchema, referenceSchema, serviceSchema, spotSchema, vehicleSchema, weightSchema, weightTypeIdSchema } from '../../../../utilis-schema/schema';
import TextField from "../../../designSystem/TextField";
import TextFieldSm from '../../../designSystem/TextFieldSm';
import TextFieldWithIcon from '../../../designSystem/TextFieldWithIcon';
import { extractTime, formatTime } from '../../../hooks/Date';
import Productdesp from '../../../Order/OrderTaking/Productdesp';
import AddAccessorial from './ButtonContent/AddAccessorial';
import AutoStatus from './ButtonContent/AutoStatus';
import DispatcherNotes from './ButtonContent/DispatcherNotes';
import Document from './ButtonContent/Document';
import OrderNotes from './ButtonContent/OrderNotes';
import SmsNotification from './ButtonContent/SmsNotification';
import ButtonModals from './ButtonModals';
import { ActionButton } from '../../../designSystem/ActionButton';
import { CardWithTitle } from '../../../designSystem/CardWithTitle';
import ShowMapModal from '../ShowMapModal';
import Button from '../../../designSystem/Button/Button';

const schema = createSchema({
    consignorName: consignorNameSchema.required(),
    pickupPhoneNumber: pickupPhoneNumberSchema.required(),
    pickupStreetNumber: pickupStreetNumberSchema.required(),
    pickupStreetName: pickupStreetNameSchema.required(),
    pickupUnit: pickupUnitSchema.required(),
    pickupCity: pickupCitySchema.required(),
    pickupProvince: pickupProvinceSchema.required(),
    pickupCountry: pickupCountrySchema.required(),
    pickupPostalCode: pickupPostalCodeSchema.required(),
    dropoffPhoneNumber: dropoffPhoneNumberSchema.required(),
    dropoffStreetNumber: dropoffStreetNumberSchema.required(),
    dropoffStreetName: dropoffStreetNameSchema.required(),
    dropoffUnit: dropoffUnitSchema.required(),
    dropoffCity: dropOffCitySchema.required(),
    dropoffProvince: dropoffProvinceSchema.required(),
    dropoffCountry: dropoffCountrySchema.required(),
    dropoffPostalCode: dropoffPostalCodeSchema.required(),
    dropoffOpeningTime: dropoffOpeningTimeSchema.required(),
    dropoffClosingTime: dropoffClosingTimeSchema.required(),
    customer: customerSchema.required(),
    vehicle: vehicleSchema.required(),
    service: serviceSchema.required(),
    pcs: pcsSchema.required(),
    spot: spotSchema.required(),
    weight: weightSchema.required(),
    weightTypeId: weightTypeIdSchema.required(),
    ft: ftSchema.required(),
    dimWgt: dimWgtSchema.required(),
    reference: referenceSchema.required(),
})

const OrderDetails = (props) => {
    const { setSelectedOrder, selectedOrder, divisionId, shouldShowGrossPriceSection } = props;
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState(null);
    const [edit, setEdit] = useState(false);
    const [editSelectedOrderDetails] = useEditSelectedOrderDetailsMutation();
    const [fetchVehicles, { data: vehicleData }] = useLazyGetVehicleByIdQuery();
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(selectedOrder?.vehicle || '');
    const [getAllActiveOrders] = useLazyGetAllActiveOpenOrdersQuery()
    const { data: orderNotifData } = useGetOrderNotificationQuery(selectedOrder?.orderNumber, { skip: !selectedOrder?.orderNumber });
    const { handleSubmit, register, formState: { errors, isValid }, reset } = useForm({ defaultValues: selectedOrder, resolver: schema });
    const [priceDetailsIsOpen, setPriceDetailsOpen] = useState(false);
    const toggleAccordion = () => { setPriceDetailsOpen(!priceDetailsIsOpen) };

    useEffect(() => {
        if (edit && selectedOrder?.accountNo) {
            // Fetch vehicles when in edit mode
            fetchVehicles(selectedOrder.accountNo);
        }
    }, [edit, selectedOrder?.accountNo]);

    useEffect(() => {
        if (selectedOrder) {
            reset(selectedOrder);
        }
    }, [selectedOrder, reset]);

    useEffect(() => {
        if (vehicleData && vehicleData.data) {
            // Filter out the current vehicle from the list
            const filteredVehicles = vehicleData.data.filter(vehicle => vehicle.vehicleType !== selectedOrder?.vehicle);
            setVehicleOptions(filteredVehicles);
        }
    }, [vehicleData, selectedOrder?.vehicle]);

    const handleEditDetails = (e) => {
        e.preventDefault();
        setSelectedOrder(selectedOrder => ({ ...selectedOrder, [e.target.name]: e.target.value }));
    };
    const editOrder = handleSubmit(async (values) => {
        if (!isValid) return
        const updatedOrder = {
            ...selectedOrder,
            vehicle: selectedVehicle
        };

        const result = await editSelectedOrderDetails(updatedOrder);
        if (result.data.statusCode === 200) {
            toast.success("Order updated successfully", {
                position: "top-center",
            });
            setEdit(false);
            // refresh data
            // After successful save, ensure the vehicle field shows the updated value
            setSelectedOrder(updatedOrder);
            getAllActiveOrders(divisionId)
        }
        else {
            toast.error("An error occurred!", {
                position: "top-center",
            });
        }
    })


    const handleShowModal = (title, content) => {
        setModalTitle(title);
        setModalContent(content);
        setModalShow(true);
    };

    const handleCloseModal = () => {
        setModalShow(false);
    };

    return (
        <div className="local-dispatch-order-details" >
            <div className="order-details-header">
                <h3 >Order #{selectedOrder?.orderNumber || ''}</h3>
            </div>
            <Row className="p-3">
                <Col lg={shouldShowGrossPriceSection ? 9 : 12}>
                    <div>
                        <div className="form-row gap-2" style={{ marginBottom: '10px' }}>
                            <div className="ready-time form-col grid-col-span-1">
                                <label style={{ marginLeft: '5px', marginRight: '5px' }}>Ready at:</label>
                                <input type="datetime-local" disabled={!edit} className="ready-date" name="readyDate" value={selectedOrder?.readyDate || ''} onChange={(e) => handleEditDetails(e)} />
                            </div>
                            <Col className='p-0'>
                                <TextField size="sm" label="Account Number" disabled {...register("accountNo")} error={errors?.accountNo?.message} />
                            </Col>
                            <Col className='p-0'>
                                <TextField size="sm" label="Account Name" disabled {...register("customer")} error={errors?.customer?.message} />
                            </Col>
                            {!shouldShowGrossPriceSection ? <div className="form-col d-flex gap-2" >
                                <ActionButton
                                    className="w-50"
                                    size='md'
                                    variant='success'
                                    icon={<BorderColorIcon />}
                                    label={edit ? "Save" : "Edit"}
                                    onClick={edit ? editOrder : () => setEdit(true)}
                                />
                                <ActionButton
                                    size='md'
                                    className="w-50"
                                    label="Exit"
                                    onClick={() => props.setSelectedOrder(null)}
                                />
                            </div> : null}
                        </div>
                        <div className="form-row">
                            <div className="local-dispatch-section w-100">
                                <CardWithTitle title="Pick-up Information" className="local-dispatch-items" variant='primary'>
                                    <div className="dispatch-items-content">
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm label="Contact" {...register('pickupContact', { onChange: (e) => handleEditDetails(e) })} disabled={!edit} error={errors?.pickupContact?.message} />
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm label="Consignor" {...register('consignorName', { onChange: (e) => handleEditDetails(e) })} disabled={!edit} error={errors?.consignorName?.message} />
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm label="Email" {...register('pickupContactEmail', { onChange: (e) => handleEditDetails(e) })} disabled={!edit} error={errors?.pickupContactEmail?.message} />
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm
                                                label="Phone #" {...register('pickupPhoneNumber', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pickupPhoneNumber?.message}
                                            />
                                        </div>
                                        <div className="form-col grid-col-span-3" >
                                            <label for='Address'>Address</label>
                                            {edit ? (
                                                <>
                                                    <TextFieldSm
                                                        placeholder="Street Number" {...register('pickupStreetNumber', { onChange: (e) => handleEditDetails(e) })}
                                                        error={errors?.pickupStreetNumber?.message}
                                                    />
                                                    <TextFieldSm
                                                        placeholder="Street Name"{...register('pickupStreetName', { onChange: (e) => handleEditDetails(e) })}
                                                        error={errors?.pickupStreetName?.message}
                                                    />
                                                    <TextFieldSm
                                                        placeholder="Unit"
                                                        {...register('pickupUnit', { onChange: (e) => handleEditDetails(e) })}
                                                        error={errors?.pickupUnit?.message}
                                                    />
                                                </>
                                            ) : (
                                                <TextFieldSm
                                                    value={`${selectedOrder?.pickupStreetNumber || ''} ${selectedOrder?.pickupStreetName || ''} ${selectedOrder?.pickupUnit ? ' Unit: ' + selectedOrder?.pickupUnit : ''}`}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="City" disabled {...register('pickupCity', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pickupCity?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Province" disabled {...register('pickupProvince', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pickupProvince?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Country" disabled {...register('pickupCountry', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pickupCountry?.message}
                                            />
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm label="Postal" disabled={!edit} {...register('pickupPostalCode', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pickupPostalCode?.message}
                                            />
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <label for='Open'>Open</label>
                                            {edit ? (
                                                <input
                                                    {...register('pickupOpeningTime', { onChange: (e) => handleEditDetails(e) })}
                                                    type="time"
                                                    name="pickupOpeningTime"
                                                    value={extractTime(selectedOrder?.pickupOpeningTime)}
                                                    onChange={(e) => handleEditDetails(e)}
                                                />
                                            ) : (
                                                <input type="text" value={formatTime(selectedOrder?.pickupOpeningTime)} disabled style={{ backgroundColor: "#FFF" }} /> // Display formatted time in AM/PM
                                            )}
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <label for='Close'>Close</label>
                                            {edit ? (
                                                <input
                                                    {...register('pickupClosingTime', { onChange: (e) => handleEditDetails(e) })}
                                                    name='pickupClosingTime'
                                                    type="time"
                                                    value={extractTime(selectedOrder?.pickupClosingTime)}
                                                    onChange={(e) => handleEditDetails(e)}
                                                />
                                            ) : (
                                                <input type="text" value={formatTime(selectedOrder?.pickupClosingTime)} disabled style={{ backgroundColor: "#FFF" }} /> // Display formatted time in AM/PM
                                            )}
                                        </div>
                                        <div className="form-col"><TextFieldSm value={selectedOrder?.pickupReference} label="Reference" disabled={!edit} /></div>
                                        <div className="form-col" >
                                            <label for='Appointment' >Appointment</label>
                                            {edit ? (
                                                <input
                                                    {...register('pickupAppointment', { onChange: (e) => handleEditDetails(e) })}
                                                    type="time"
                                                    value={extractTime(selectedOrder?.pickupAppointment)}
                                                    onChange={(e) => handleEditDetails(e)}
                                                />
                                            ) : (
                                                <input type="text" value={formatTime(selectedOrder?.pickupAppointment)} disabled style={{ backgroundColor: "#FFF" }} />
                                            )}
                                        </div>
                                        <div className="form-col"><TextFieldSm label="IN" disabled={!edit} /></div>
                                        <div className="form-col"><TextFieldSm label="OUT" type="text" value={formatTime(selectedOrder?.pickupOutTime)} disabled={!edit} /></div>
                                        <div className="form-col"><TextFieldSm label="ETA" disabled={!edit} /></div>
                                        <div className="form-col"><TextFieldSm label="Detention" disabled={!edit} /></div>
                                        <div className="form-col"><TextFieldSm label="Driver" {...register("pickupDriver", { onChange: (e) => handleEditDetails(e) })} disabled={!edit || selectedOrder?.orderStatus === "Open"} /></div>
                                    </div>
                                </CardWithTitle>
                                <CardWithTitle title="Drop-off Information" className="local-dispatch-items" variant='secondary'>
                                    <div>
                                        <div className="dispatch-items-content">
                                            <div className="form-col grid-col-span-2">
                                                <TextFieldSm label="Contact" disabled={!edit} {...register('dropoffContact', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffContact?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <TextFieldSm label="Consignee" disabled={!edit} {...register('consigneeName', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.consigneeName?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <TextFieldSm label="Email" disabled={!edit} {...register('dropoffContactEmail', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffContactEmail?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <TextFieldSm label="Phone #" disabled={!edit} {...register('dropoffPhoneNumber', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffPhoneNumber?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-3">
                                                <label for='Address'>Address</label>
                                                {edit ? (
                                                    <>
                                                        <TextFieldSm placeholder="Street Number" disabled={!edit} {...register('dropoffStreetNumber', { onChange: (e) => handleEditDetails(e) })}
                                                            error={errors?.dropoffStreetNumber?.message}
                                                        />
                                                        <TextFieldSm placeholder="Street Name" disabled={!edit} {...register('dropoffStreetName', { onChange: (e) => handleEditDetails(e) })}
                                                            error={errors?.dropoffStreetName?.message}
                                                        />
                                                        <TextFieldSm placeholder="Unit" disabled={!edit} {...register('dropoffUnit', { onChange: (e) => handleEditDetails(e) })}
                                                            error={errors?.dropoffStreetName?.message}
                                                        />
                                                    </>
                                                ) : (
                                                    <TextFieldSm
                                                        value={`${selectedOrder?.dropoffStreetNumber || ''} ${selectedOrder?.dropoffStreetName || ''} ${selectedOrder?.dropoffUnit ? ' Unit: ' + selectedOrder?.dropoffUnit : ''}`}
                                                        disabled
                                                    />
                                                )}
                                            </div>
                                            <div className="form-col">
                                                <TextFieldSm label="City" disabled {...register('dropoffCity', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffCity?.message}
                                                />
                                            </div>
                                            <div className="form-col">
                                                <TextFieldSm label="Province" disabled {...register('dropoffProvince', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffProvince?.message}
                                                />
                                            </div>
                                            <div className="form-col">
                                                <TextFieldSm label="Country" disabled {...register('dropoffCountry', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffCountry?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <TextFieldSm label="Postal" disabled={!edit} {...register('dropoffPostalCode', { onChange: (e) => handleEditDetails(e) })}
                                                    error={errors?.dropoffPostalCode?.message}
                                                />
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <label for="Open" >Open</label>
                                                {edit ? (
                                                    <input
                                                        {...register('dropoffOpeningTime', { onChange: (e) => handleEditDetails(e) })}
                                                        type="time"
                                                        name="dropoffOpeningTime"
                                                        value={extractTime(selectedOrder?.dropoffOpeningTime)}
                                                        onChange={(e) => handleEditDetails(e)}
                                                    />
                                                ) : (
                                                    <input type="text" value={formatTime(selectedOrder?.dropoffOpeningTime)} disabled style={{ backgroundColor: "#FFF" }} /> // Display formatted time in AM/PM
                                                )}
                                            </div>
                                            <div className="form-col grid-col-span-2">
                                                <label for="Close" >Close</label>
                                                {edit ? (
                                                    <input
                                                        {...register('dropoffClosingTime', { onChange: (e) => handleEditDetails(e) })}
                                                        type="time"
                                                        name="dropoffClosingTime"
                                                        value={extractTime(selectedOrder?.dropoffClosingTime)}
                                                        onChange={(e) => handleEditDetails(e)}
                                                    />
                                                ) : (
                                                    <input type="text" value={formatTime(selectedOrder?.dropoffClosingTime)} disabled={!edit} style={{ backgroundColor: "#FFF" }} /> // Display formatted time in AM/PM
                                                )}
                                            </div>
                                            <div className="form-col"><TextFieldSm value={selectedOrder?.dropoffReference} label="Reference" disabled={!edit} /></div>
                                            <div className="form-col">
                                                <label for='Appointment'>Appointment</label>
                                                {edit ? (
                                                    <input
                                                        {...register('dropoffAppointment', { onChange: (e) => handleEditDetails(e) })}
                                                        type="time"
                                                        name="dropoffAppointment"
                                                        value={extractTime(selectedOrder?.dropoffAppointment)}
                                                        onChange={(e) => handleEditDetails(e)}
                                                    />
                                                ) : (
                                                    <input type="text" value={formatTime(selectedOrder?.dropoffAppointment)} disabled={!edit} style={{ backgroundColor: "#FFF" }} /> // Display formatted time in AM/PM
                                                )}
                                            </div>
                                            <div className="form-col"><TextFieldSm label="IN" disabled={!edit} /></div>
                                            <div className="form-col"><TextFieldSm label="OUT" type="text" value={formatTime(selectedOrder?.deliveryOutTime)} disabled={!edit} /></div>
                                            <div className="form-col"><TextFieldSm label="ETA" disabled={!edit} /></div>
                                            <div className="form-col"><TextFieldSm label="Detention" disabled={!edit} /></div>
                                            <div className="form-col"><TextFieldSm label="Driver" {...register("dropoffDriver", { onChange: (e) => handleEditDetails(e) })} disabled={!edit || selectedOrder?.orderStatus === "Open"} /></div>
                                        </div>
                                    </div>
                                </CardWithTitle>
                                <CardWithTitle title="Order Information" className="local-dispatch-items">
                                    <div className="dispatch-items-content">
                                        <div className="form-col grid-col-span-2">
                                            <label for="Vehicle" >Vehicle </label>
                                            {!edit ? (
                                                <TextFieldSm disabled value={selectedOrder?.vehicle || ''} />
                                            ) : (
                                                <>
                                                    <select
                                                        {...register('vehicle', { onChange: (e) => handleEditDetails(e) })}
                                                        value={selectedVehicle}
                                                        onChange={(e) => setSelectedVehicle(e.target.value)}
                                                    >
                                                        <option value={selectedOrder?.vehicle || ''}>{selectedOrder?.vehicle || 'Select Vehicle'}</option>
                                                        {vehicleOptions.map((vehicle) => (
                                                            <option key={vehicle.vehicleID} value={vehicle.vehicleType}>
                                                                {vehicle.vehicleType}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <p style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                                                        If the vehicle is changed, you need to select a new service based on the selected vehicle.
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                        <div className="form-col grid-col-span-2">
                                            <TextFieldSm label="Service" disabled {...register('service', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.service?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Pcs" disabled={!edit}  {...register('pcs', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.pcs?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Spot" disabled={!edit}  {...register('spot', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.spot?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Weight" disabled={!edit}  {...register('weight', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.weight?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <label for="size">Weight type </label>
                                            <TextFieldSm disabled {...register('weightTypeId', { onChange: (e) => handleEditDetails(e) })} value={selectedOrder?.weightTypeId == 1 ? 'L' : ''} onChange={(e) => handleEditDetails(e)} />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Ft" disabled={!edit}  {...register('ft', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.ft?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Dim. Weight" disabled={!edit}  {...register('dimWgt', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.dimWgt?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Reference" disabled={!edit}  {...register('reference', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.reference?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Trip Number" disabled={!edit}  {...register('tripNo', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.tripNo?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Waybill" disabled={!edit}  {...register('waybill', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.waybill?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Order Taker" disabled={!edit}  {...register('orderTaker', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.orderTaker?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm label="Invoice Number" disabled={!edit}  {...register('invoice', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.invoice?.message}
                                            />
                                        </div>
                                        <div className="form-col">
                                            <TextFieldSm style={{ borderRadius: "3px", padding: "1px 2px", border: "1px solid #ccc" }}
                                                type="date" label="Invoice Date" disabled={!edit}  {...register('invoiceDate', { onChange: (e) => handleEditDetails(e) })}
                                                error={errors?.invoiceDate?.message}
                                            />
                                        </div>
                                    </div>
                                    <div className='border border-grey rounded-2 text-sm px-3'>
                                        <div className='rounded-2 bg-primary'>
                                            <p className='text-white p-2 m-0'>SIGNED BY (Drop-up)</p>
                                        </div>
                                        <div className='my-2'>
                                            <TextField size="sm" className="w-50" label="Signature" />
                                        </div>
                                    </div>
                                    <div className='border border-grey rounded-2 text-sm px-3'>
                                        <div className='rounded-2 mb-1 bg-success'>
                                            <p className='text-white p-2 m-0'>SIGNED BY (Pick-up)</p>
                                        </div>
                                        <div className='my-2'>
                                            <TextField size="sm" className="w-50" label="Signature" />
                                        </div>
                                    </div>
                                </CardWithTitle>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex gap-2 flex-wrap mb-2">
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('Add Accessorial', <AddAccessorial selectedOrder={selectedOrder} setSelectedOrder={setSelectedOrder} divisionId={divisionId} />)}>Add Accessorial</Button>
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('Auto Status', <AutoStatus selectedOrder={selectedOrder} orderNotifData={orderNotifData} />)}>Auto Status</Button>
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('Document', <Document selectedOrder={selectedOrder} orderNotifData={orderNotifData} />)}>Document</Button>
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('SMS', <SmsNotification selectedOrder={selectedOrder} orderNotifData={orderNotifData} />)}>SMS</Button>
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('Dispatcher Notes', <DispatcherNotes selectedOrder={selectedOrder} orderNotifData={orderNotifData} setSelectedOrder={setSelectedOrder} divisionId={divisionId} />)}>Dispatcher Notes</Button>
                                <Button fullWidth={false} variant='outline-primary' onClick={() => handleShowModal('Order Notes', <OrderNotes selectedOrder={selectedOrder} orderNotifData={orderNotifData} setSelectedOrder={setSelectedOrder} divisionId={divisionId} />)}>Order Notes</Button>
                                <ShowMapModal showTextButton={true} divisionId={divisionId} orderId={selectedOrder?.orderId} />
                                <Button fullWidth={false} variant='outline-primary'>Return No Delivery</Button>
                                <Button fullWidth={false} variant='outline-primary'>Future</Button>
                                <GenerateOrder>
                                    <Productdesp variant='outline-primary' divisionId={divisionId} orderId={selectedOrder?.orderId} />
                                </GenerateOrder>
                            </div>
                            <ButtonModals show={modalShow} title={modalTitle} content={modalContent} handleClose={handleCloseModal} />
                        </div>
                    </div>
                </Col>
                {shouldShowGrossPriceSection ? <Col lg={3}>
                    <div className='d-flex  gap-2 mb-2'>
                        <ActionButton
                            className='w-50'
                            variant='outline-secondary'
                            icon={<LocalShippingIcon sx={{ fontSize: "16px !important" }} />}
                            label="Re-Dispatch"
                            disabled
                        />
                        <ActionButton
                            className='w-25'
                            variant='success'
                            icon={<BorderColorIcon sx={{ fontSize: "16px !important" }} />}
                            label={edit ? "Save" : "Edit"}
                            onClick={edit ? editOrder : () => setEdit(true)}
                        />
                        <ActionButton
                            className='w-25'
                            label="Exit"
                            onClick={() => props.setSelectedOrder(null)}
                        />
                    </div>
                    <div style={{ backgroundColor: "#244da180" }} className='px-2 mb-2 pb-3 pt-2 rounded-3'>
                        <div style={{ backgroundColor: "white", padding: "6px", borderRadius: "5px" }}>
                            <TextFieldWithIcon placeholder="Gross Price" icon="$" />
                            <Button className="my-2" onClick={toggleAccordion}>
                                View Gross Price Details
                            </Button>
                            <Accordion activeKey={priceDetailsIsOpen ? "0" : null}>
                                <Accordion.Collapse eventKey="0">
                                    <Stack gap={2} style={{ backgroundColor: "#244da180", padding: "8px", borderRadius: "5px" }}>
                                        <TextFieldWithIcon placeholder="Gross Price" icon="$" />
                                        <TextFieldWithIcon placeholder="Accessorial" icon="$" />
                                        <TextFieldWithIcon placeholder="Gross Price" icon="$" />
                                        <TextFieldWithIcon placeholder="Total Quote Price" icon="$" />
                                    </Stack>
                                </Accordion.Collapse>
                            </Accordion>
                        </div>
                    </div>
                </Col > : null}
            </Row >
        </div >
    );
};

export default OrderDetails;


